import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { COMPANY, CHARGERS, PLATFORM_COMMERCIAL, DEFAULT_TEXTOS, DEFAULT_IMAGENS } from "@/lib/siteContent";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULT_CONTENT = {
  company: COMPANY,
  chargers: CHARGERS,
  platformCommercial: PLATFORM_COMMERCIAL,
  textos: DEFAULT_TEXTOS,
  imagens: DEFAULT_IMAGENS,
};

const ContentContext = createContext(DEFAULT_CONTENT);

export function ContentProvider({ children }) {
  const { pathname } = useLocation();
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    axios
      .get(`${API}/content`)
      .then(({ data }) => {
        if (data && Object.keys(data).length) {
          setContent({
            company: { ...COMPANY, ...(data.company || {}) },
            chargers:
              Array.isArray(data.chargers) && data.chargers.length
                ? data.chargers
                : CHARGERS,
            platformCommercial: data.platformCommercial || PLATFORM_COMMERCIAL,
            textos: { ...DEFAULT_TEXTOS, ...(data.textos || {}) },
            imagens: { ...DEFAULT_IMAGENS, ...(data.imagens || {}) },
          });
        }
      })
      .catch(() => {});
  }, [pathname]);

  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);

export const resolveImg = (foto) =>
  !foto || foto.startsWith("/") || foto.includes("://")
    ? foto
    : `${API}/files/${foto}`;

export const isLocalImg = (foto) =>
  !!foto && (foto.startsWith("/") || !foto.includes("pexels.com"));

export { DEFAULT_CONTENT };
